import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

export interface INavBarText {
  Home: string;
  AboutHeading: string;
  About: string;
  History: string;
  Gallery: string;
  Partners: string;
  FAQ: string;
  Rules: string;
  Events: string;
  Contact: string;
  Register: string;
  Tournaments: string;
  WorldFinals: string | null;
  Scores: string | null;
  Logo: {
    src: string;
  } | null;
}
interface IColorQueryResult {
  fetch: {
    Common: {
      Header: {
        BackgroundColor: string;
        BackgroundImage: {
          src: string;
        } | null;
      };
      Footer: {
        BackgroundColor: string | null;
        BackgroundImage: {
          src: string;
        } | null;
        FooterImage1: {
          src: string;
        } | null;
        FooterImage2: {
          src: string;
        } | null;
      } | null;
      FAQ: {
        Lists: {
          QuestionsBackground: string | null;
        } | null;
      } | null;
      Sponsors: {
        Background: string | null;
      } | null;
      ButtonColor: string | null;
    };
    Country: {
      Settings: {
        PrimaryLanguage: string | null;
        SecondaryLanguage: string | null;
        RightToLeft: string | null;
        RightToLeftSecondary: string | null;
        DualLanguage: string | null;
        EnglishName: string | null;
      } | null;
      Scores: {
        Active: string | null;
      } | null;
      HomePage: {
        NewsSection: {
          ReadMore: string | null;
        } | null;
      };
      Name: string;
      Navbar?: INavBarText;
      FooterConfig: {
        PartnerText: string | null;
        PartnerLink: string | null;
        FooterText: string | null;
      } | null;
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithColorQueryProps = QueryResult<IColorQueryResult>;

class ColorQuery extends Query<IColorQueryResult, IVariables> {}

const withColorQuery = <P extends WithColorQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<Subtract<P, WithColorQueryProps> & IRequiredProps> => props => {
  const { country } = props;
  return (
    <ColorQuery
      query={queries.GET_COLOR_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => {
        if (
          !providedProps.loading &&
          providedProps.data &&
          providedProps.data.fetch.Country.Settings &&
          typeof providedProps.data.fetch.Country.Settings.RightToLeft ===
            'string'
        ) {
          if (providedProps.data.fetch.Country.Settings.RightToLeft === 'yes') {
            document.getElementsByTagName('body')[0].dir = 'rtl';
          }
        } else {
          document.getElementsByTagName('body')[0].dir = '';
        }
        return <Component {...providedProps} {...props as any} />;
      }}
    </ColorQuery>
  );
};

export default withColorQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withColorQuery.tsx